const API_TOKEN = "API_TOKEN";
const DEVICE_TOKEN = "DEVICE_TOKEN";
const AGALIA_ID = "AGALIA_ID";
const STAFFING_ID = "STAFFING_ID";
const ROLE = "ROLE";
export { API_TOKEN, DEVICE_TOKEN, AGALIA_ID, STAFFING_ID, ROLE };
